/** Resolve a numeric value from a chart row (flat or nested). */
export function pickRowNumber(row, paths) {
  if (!row) return 0;
  for (const path of paths) {
    if (path.includes(".")) {
      const v = path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), row);
      if (v != null && Number.isFinite(Number(v))) return Number(v);
    } else if (row[path] != null && Number.isFinite(Number(row[path]))) {
      return Number(row[path]);
    }
  }
  return 0;
}

export function extractSeries(rows, paths) {
  if (!rows?.length) return [];
  return rows.map((r) => pickRowNumber(r, paths));
}

export function sumSeries(arr) {
  return arr.reduce((s, v) => s + (Number(v) || 0), 0);
}

/**
 * Compare second half of series to first half (simple period trend for sparkline data).
 * Returns { pct, direction } where direction is 'up' | 'down' | 'flat'.
 */
export function halfSplitTrend(series) {
  const s = (series || []).map((v) => Number(v) || 0);
  if (s.length < 2) return { pct: null, direction: "flat", delta: null };
  const mid = Math.floor(s.length / 2) || 1;
  const first = s.slice(0, mid).reduce((a, b) => a + b, 0);
  const second = s.slice(mid).reduce((a, b) => a + b, 0);
  const base = Math.abs(first) < 1e-9 ? Math.abs(second) < 1e-9 ? 1 : Math.abs(second) : Math.abs(first);
  const pct = ((second - first) / base) * 100;
  const delta = second - first;
  if (Math.abs(pct) < 0.05) return { pct: 0, direction: "flat", delta: 0 };
  return { pct, direction: pct > 0 ? "up" : "down", delta };
}
